import * as z from 'zod';

export const ProductionCategorySchema = z.object({
    "id": z.number(),
    "is_active": z.boolean(),
    "name": z.string()
});

export const ProductionCategoryPartialSchema = ProductionCategorySchema.partial();
export type ProductionCategoryPartial = z.infer<typeof ProductionCategoryPartialSchema>;
export type ProductionCategory = z.infer<typeof ProductionCategorySchema>;

export function newProductionCategory(data: unknown) {
    if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }

    if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }

    return {
        ...ProductionCategorySchema.parse({...data})
    };
}

export function parseProductionCategory(data: any, partial = false) {
    if (!partial) {
        return {
            ...ProductionCategorySchema.parse(data)
        };
    }
    else if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }
    else if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    else if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }
    else {
        return {
            ...ProductionCategoryPartialSchema.parse(data)
        };
    }
}
